const getHearAboutUsOptions = (t) => [
    {
        label: t('source-choice-1'),
        value: 'Online Advertisement',
    },
    {
        label: t('source-choice-2'),
        value: 'Online Search',
    },
    {
        label: t('source-choice-3'),
        value: 'News Articles',
    },
    {
        label: t('source-choice-4'),
        value: 'TV / Radio Broadcast',
    },
    {
        label: t('source-choice-5'),
        value: 'Events',
    },
    {
        label: t('source-choice-6'),
        value: 'Online Webinar',
    },
    {
        label: t('source-choice-7'),
        value: 'Social Media',
    },
    {
        label: t('source-choice-8'),
        value: 'e-Newsletter',
    },
    {
        label: t('source-choice-9'),
        value: 'Referral',
    },
    {
        label: t('source-choice-10'),
        value: 'Others',
    },
];

export default getHearAboutUsOptions;
